export type TransactionAction = 'remove'

export const TRANSACTION_ACTION_LABELS: Record<TransactionAction, string> = {
  remove: 'Remove Transaction',
}

export const TRANSACTION_ACTION_DESCRIPTIONS: Record<
  TransactionAction,
  string
> = {
  remove: 'Remove a transaction from the system',
}
